<template>
  <div>
    <textarea
      v-model="model.delete_reason"
      :placeholder="placeholder"
      rows="3"
      class="form-control"
      :class="{ 'is-invalid': errors.has('delete_reason') }"
    ></textarea>
    <div class="invalid-feedback" v-if="errors.has('delete_reason')">
      {{ errors.first('delete_reason') }}
    </div>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'reasonDelete',
  props: ['value', 'validate', 'placeholder'],
  data() {
    return {
      model: {},
      errors: new Errors()
    }
  },
  created() {
    this.model = this.value
  },
  methods: {},
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
